import {
  buildUndeliveredQuantitySearch,
  effectiveUndeliveredPeriod,
} from './undeliveredQuantityFilters'

/**
 * Query string for payment-processing, aligned with dashboard global filters + period.
 */
export function buildPaymentProcessingSearch(filters = {}, { status } = {}, now = new Date()) {
  const params = new URLSearchParams(buildUndeliveredQuantitySearch(filters, now))
  if (status) params.set('status', status)
  return params.toString()
}

export { effectiveUndeliveredPeriod }
